import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useUserStore from "../../../../utils/storeApp";
import CallAPI from "../../../../services/apiCalls";
import $ from "jquery";
import { stateCodeArray } from "../../../../services/fakeDB/ListUser";
import SpecialtyDropdown from "../../../shared/SpecialtyDropdown";
import Npi from "../../../shared/NPI/NPI";
/*import NoReply from "../../../emails/NoReply";*/
import { usePortalAuthentication } from "../../../../services/authorizationService";

const o = {
  Addressess: {
    FirstLine: "",
    SecondLine: "",
    City: "",
    State: "",
    PostalCode: "",
    Country: "USA",
    Phone: "",
    PhoneExt: "",
    Fax: "",
    FaxExt: "",
  },
  Administrator: false,
  AllowDMEAccess: false,
  AllowENSAccess: false,
  AllowFormsAccess: false,
  AllowPriorAuthAccess: false,
  ClaimsAttachmentPayer: false,
  ClaimsAttachmentProvider: false,
  ClaimsAttachmentStaff: false,
  ContactEmail: "",
  CreateUsers: false,
  Credential: "",
  ParentVendorId: "",
  UserType: null,
  DME_Payer: false,
  DME_Provider: false,
  DME_Staff: false,
  DME_Supplier: false,
  DirectEmail: false,
  DomainName: "",
  FirstName: "",
  FullName: "",
  HasAddresses: false,
  HasSpecialties: false,
  IDs: [],
  Id: null,
  IsLockedByAdmin: false,
  IssueInvites: false,
  LastLoginTime: null,
  LastName: "",
  LockoutEnabled: false,
  LockoutEndDate: null,
  NPI: null,
  PreAuthProvider: false,
  PreAuthReviewer: false,
  PreAuthStaff: false,
  PreAuthSupervisor: false,
  RegistrationStatus: 5,
  RequireIdVerification: true,
  SESAdministrator: false,
  Specialties: [null],
  Status: "Completed",
  TFAEmail: "",
  TFAOn: false,
  TFAPhone: null,
  TrustedAgent: false,
  TwoFactorEnabled: true,
  UserDirectEmailId: null,
  UserName: "",
  UserNameDisplay: "",
  UserTypeString: "",
  VendorEmailForwardingType: null,
  VendorEmailForwardingTypeString: "",
  NoReply: false,
};
function  formatZipCode(value){
    if (!value) return value;
    const zip = value.replace(/[^\d]/g, "");
    const zipLength = zip.length;
    if (zipLength < 6) return zip;
    return `${zip.slice(0, 5)}`;
    //return `${zip.slice(0, 5)}-${zip.slice(5, 9)}`;
}
function formatPhoneNumber(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}
const FormUserContact = () => {
  const navigate = useNavigate();
  const { logout } = usePortalAuthentication();
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [answers, setAnswers] = useState(o);
  const [processing, SetProcessing] = useState(false);
  const [userObj, SetUserObj] = useState({});
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [errEmail, SetErrEmail] = useState(false);
  const [frmSubmFlag, SetSubmitFlag] = useState(false);
  const [userEditDetails, SetuserEditDetails] = useState({
    specialties: [null],
  });
  const [specialtiesFlag, SetspecialtiesFlag] = useState(false);
  const setAnswer = async (questionId, answer, chck) => {
    if (chck) {
      let obj = { ...answers };
      let add = answers.Addressess;
      add[questionId] = answer;
      obj.Addressess = add;
      await setAnswers(obj);
    } else {
      await setAnswers({ ...answers, [questionId]: answer });
    }
  };
  const getUserDetailsById = async (id) => {
    SetProcessing(true);
    let call = "/users/GetPreRegUserById?userId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res?.data?.data;
      let ob = {
        ...answers,
        NamePrefix: det.namePrefix,
        FirstName: det.firstName,
        LastName: det.lastName,
        UserName: det.userName,
        DomainName: det.domainName,
        ParentOrganizationId: det.org_id,
        ParentVendorId: det.vendorId,
        Credential: det.credential,
      };
      await setAnswers(ob);
      SetUserObj(det);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetErrMsg(`<div>${res.data.message}</div>`);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
  };
  useEffect(() => {
    PreRegistration();
    SetspecialtiesFlag(false);
    return () => {
      setAnswers(o);
      SetspecialtiesFlag(false);
      SetErrEmail(false);
    };
  }, []);
  const PreRegistration = async () => {
    getUserDetailsById(userSession.sesuser_id);
  };
  const CheckSpecialty = () => {
    let flag =
      isEmpty(sharedObject.specialties.Code) &&
      (!isEmpty(sharedObject.specialties.Type) ||
        !isEmpty(sharedObject.specialties.Classification));
    return flag;
  };
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
    }

  const AddUserRegistration = async () => {
    SetSubmitFlag(true);
    SetErrCreateMsg(false);
    SetspecialtiesFlag(false);
    SetErrEmail(false);
    if (!answers.FirstName === "") {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    } else if (!answers.LastName === "") {
      document.getElementById("LastName").scrollIntoView();
      document.getElementById("LastName").focus();
      return;
    } else if (answers.Addressess.FirstLine === "") {
      document.getElementById("FirstLine").scrollIntoView();
      document.getElementById("FirstLine").focus();
      return;
    } else if (answers.Addressess.City === "") {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (answers.Addressess.State === "") {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (answers.Addressess.PostalCode === "") {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    } else if (!isEmpty(sharedObject.specialties) && CheckSpecialty()) {
      SetspecialtiesFlag(true);
      return;
    } else if (
      (userObj.includeDirectEmail && answers.ContactEmail === "") ||
      (answers.ContactEmail !== "" &&
        (containsSpacesOrSpecialChars(answers.ContactEmail) ||
          answers.ContactEmail.length < 4))
    ) {
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      SetErrEmail(true);
      return;
      }
      if (answers.FirstName.length > 20) {
          document.getElementById("FirstName").scrollIntoView();
          document.getElementById("FirstName").focus();
          return;
      }
    answers.NamePrefix = isEmpty(answers.NamePrefix)
      ? null
      : parseInt(answers.NamePrefix);
    answers.Addressess.Phone =
      answers.Addressess.Phone.replace(/[^0-9]/g, "").substring(0, 10) +
      answers.Addressess.PhoneExt;
    answers.Addressess.Fax = answers.Addressess.Fax
      ? answers.Addressess.Fax.replace(/[^0-9]/g, "").substring(0, 10)
          : "" + answers.Addressess.FaxExt;
      if (validatePhoneNumber(answers.Addressess.Phone, false)) {
        document.getElementById("Phone").scrollIntoView();
        document.getElementById("Phone").focus();
        return;
      }
      if (validatePhoneNumber(answers.Addressess.Fax, true)) {
        document.getElementById("Fax").scrollIntoView();
        document.getElementById("Fax").focus();
        return;
      }
      answers.Addressess.PostalCode = answers.Addressess.PostalCode.replace(/[^0-9]/g, "").substring(0, 9);
      if (validateZip(answers.Addressess.PostalCode)) {
          document.getElementById("PostalCode").scrollIntoView();
          document.getElementById("PostalCode").focus();
          return;
      }
    answers.Addresses = [answers.Addressess];
    SetProcessing(true);
    answers.FullName = answers.FirstName + answers.LastName;
    let dEmail = answers.ContactEmail ? answers.ContactEmail : null;
    let sCode = null;
    if (answers.specializationCode) {
      sCode = answers.specializationCode;
    } else {
      answers.Specialties = [];
    }
    let call =
      "/users/RegisterUser?directEmail=" +
      dEmail +
      "&specializationCode=" +
      sCode +
      "&NoReply=" +
      answers.NoReply;
    const res = await CallAPI(call, answers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      if (userObj.requireIdVerification) {
        navigate("/experian-sso");
      } else {
        navigate("/success-pre-registration");
      }
    } else if (res.status === "SERVERERROR" || res.status === "ECONNABORTED") {
      let msg = res.data;
      let str = "";
      if (typeof msg === "string") {
        str = msg;
      } else {
        str = "<div>";
        str +=
          "We have encountered an system error and it is not responding.Please try again and contact support if the problem persists.";
        // for (let el of msg) {
        //   str += `${el}`;
        // }
        str += "</div>";
      }

      SetErrMsg(str);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
    // success navigate to={"/registration-success"}
  };
  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      Specialties: [val],
      specializationCode: val.Code,
    });
  };
  function Confirm() {
    $("#ConfirmModal").modal("show");
  }
  const containsSpacesOrSpecialChars = (str) => {
    let flag = /[^a-zA-Z0-9-_@.]/.test(str);
    return flag;
    };
    const validateZip = (str) => {
        let flag = false;
        if (str.length !== 5 && str.length !== 9) {
            flag = true;
        }
        return flag;
    }
  const validatePhoneNumber = (str, isFax) => {
    let flag = /[^0-9.]/.test(str);
      if (isFax === false && str.length < 10) {
          flag = true;
      } else if (isFax === true && str.length > 0 && str.length < 10) {
          flag = true;
      }
    return flag;
  };
  const userEdit = (obj) => {
    setAnswers({
      ...answers,
      OrganizationName: obj.Name,
      Addressess: obj.Addresses,
      NPI: obj.NPI,
    });
  };
  return (
    <div className="FormUserContact">
      <div className="sp-pad">
        <div className="form-container">
          <label for="">Provider</label>
          <Npi userEdit={userEdit} />
          <div className="field-wrapper spacer-inline spacer-margin5 v-top">
            {/*Prefix*/}
            <label for="prefix">Prefix</label>
            <select
              className="form-control field-ext"
              name="prefix"
              onChange={(el) => setAnswer("NamePrefix", el.target.value)}
              value={answers.NamePrefix}
            >
              <option value="">Select</option>
              <option value="5">Prof</option>
              <option value="4">Dr</option>
              <option value="1">Mr</option>
              <option value="3">Mrs</option>
              <option value="2">Miss</option>
            </select>
          </div>
          {/*First Name*/}
          <div className="field-wrapper w-lg6 spacer-inline v-top">
            <label for="FirstName">First Name</label>
            <input
              type="text"
              className="form-control"
              id="FirstName"
              onChange={(el) => setAnswer("FirstName", el.target.value)}
              value={answers.FirstName}
            />
            {answers.FirstName === "" && frmSubmFlag ? (
              <div className="alert alert-danger">First name is required.</div>
            ) : null}
            {answers.FirstName.length > 20 && frmSubmFlag ? (
              <div className="alert alert-danger">Cannot be more than 20 characters</div>
            ) : null}
          </div>
          {/*Last Name*/}
          <div className="field-wrapper field-box2">
            <label for="LastName">Last Name</label>
            <input
              type="text"
              className="form-control"
              id="LastName"
              onChange={(el) => setAnswer("LastName", el.target.value)}
              value={answers.LastName}
            />
            {answers.FirstName === "" && frmSubmFlag ? (
              <div className="alert alert-danger"> Last name is required. </div>
            ) : null}
          </div>
          {/*Credential optional*/}
          <div className="field-wrapper field-box3">
            <label for="credential">Credential</label>
            <input
              className="form-control"
              name="credential"
              placeholder="Optional"
              onChange={(el) => setAnswer("Credential", el.target.value)}
              value={answers.Credential}
            />
          </div>
          {/*Address 1*/}
          <div className="field-wrapper field-box2">
            <label for="username">Address 1</label>
            <input
              className="form-control"
              name="address1"
              id="FirstLine"
              onChange={(el) => setAnswer("FirstLine", el.target.value, true)}
              value={answers.Addressess.FirstLine}
            />
            {answers.Addressess.FirstLine === "" && frmSubmFlag ? (
              <div className="alert alert-danger"> Address is required. </div>
            ) : null}
          </div>
          {/*Address 2 optional*/}
          <div className="field-wrapper field-box3">
            <label for="LastLine">Address 2</label>
            <input
              className="form-control"
              name="address2"
              placeholder="Optional"
              id="LastLine"
              onChange={(el) => setAnswer("SecondLine", el.target.value, true)}
              value={answers.Addressess.SecondLine}
            />
          </div>
          {/*City*/}
          <div className="field-wrapper">
            <div className="field-box2 spacer-inline v-top">
              <label for="city">City</label>
              <input
                className="form-control"
                name="city"
                id="City"
                onChange={(el) => setAnswer("City", el.target.value, true)}
                value={answers.Addressess.City}
              />
              {answers.Addressess.City === "" && frmSubmFlag ? (
                <div className="alert alert-danger"> City is required. </div>
              ) : null}
            </div>
            {/*State*/}
            <div className="field-ext spacer-inline spacer-margin5 v-top">
              <label for="state">State</label>
              <select
                className="form-control"
                name="state"
                id="State"
                onChange={(el) => setAnswer("State", el.target.value, true)}
                value={answers.Addressess.State}
              >
                <option value={""}>Select</option>
                {stateCodeArray.map((el) => (
                  <option key={el} value={el}>
                    {el}
                  </option>
                ))}
              </select>
              {answers.Addressess.State === "" && frmSubmFlag ? (
                <div className="alert alert-danger"> State is required. </div>
              ) : null}
            </div>
            {/*Zip Code*/}
            <div className="field-ext spacer-inline v-top">
              <label for="zip">Zip</label>
              <input
                className="form-control"
                name="zip"
                id="PostalCode"
                value={answers.Addressess.PostalCode}
                maxLength={5}
                onChange={(el) =>{
                  setAnswer("PostalCode", el.target.value, true)}
                }
                
              />
              {answers.Addressess.PostalCode === "" && frmSubmFlag ? (
                <div className="alert alert-danger">
                  Zip is required.
                </div>
                          ) : null}
            {((answers.Addressess.PostalCode.replace(/[^0-9]/g, "").substring(0, 9).length !== 9 && frmSubmFlag) && (answers.Addressess.PostalCode.replace(/[^0-9]/g, "").substring(0, 9).length !== 5 && frmSubmFlag)) && (answers.Addressess.PostalCode.replace(/[^0-9]/g, "").substring(0, 9).length > 0) ? (
              <div className="alert alert-danger">Invalid Zip Code.</div>
            ) : null}
            </div>
          </div>
          {/*Phone*/}
          <div className="field-wrapper ">
            <div className="field-box2 spacer-inline v-top">
              <label for="">Phone</label>
              <input
                className="form-control"
                id="Phone"
                name="Phone"
                onChange={(el) => setAnswer("Phone", el.target.value, true)}
                value={formatPhoneNumber(answers.Addressess.Phone)}
              />
              {answers.Addressess.Phone === "" && frmSubmFlag ? (
              <div className="alert alert-danger">
                Phone number is required.
              </div>
            ) : null}
            {(answers.Addressess.Phone.replace(/[^0-9]/g, "").substring(0, 10).length < 10 && frmSubmFlag) && (answers.Addressess.Phone.replace(/[^0-9]/g, "").substring(0, 10).length > 0 && frmSubmFlag) ? (
              <div className="alert alert-danger">
                Invalid Phone Number.
              </div>
            ) : null}
            </div>
            
            <div className="field-box3">
              <label for="OrgName">Ext</label>
              <input
                className="form-control"
                name=""
                onChange={(el) => setAnswer("PhoneExt", el.target.value, true)}
                value={answers.Addressess.PhoneExt}
              />
            </div>
          </div>
          {/*Fax*/}
          <div className="field-wrapper">
            <div className="field-box2 spacer-inline v-top">
              <label for="OrgName">Fax</label>
              <input
                className="form-control"
                name="FaxNumber"
                id="Fax"
                placeholder="Optional"
                onChange={(el) => setAnswer("Fax", el.target.value, true)}
                value={formatPhoneNumber(answers.Addressess.Fax)}
              />
             
            {(answers.Addressess.Fax.replace(/[^0-9]/g, "").substring(0, 10).length < 10 && frmSubmFlag) && (answers.Addressess.Fax.replace(/[^0-9]/g, "").substring(0, 10).length > 0 && frmSubmFlag) ? (
              <div className="alert alert-danger">Invalid Fax Number.</div>
            ) : null}
            </div>
            <div className="field-box3">
              <label for="OrgName">Ext</label>
              <input
                className="form-control"
                name="OrgName"
                onChange={(el) => setAnswer("FaxExt", el.target.value, true)}
                value={answers.Addressess.FaxExt}
              />
            </div>
          </div>
          {userObj?.includeDirectEmail ? (
            <>
              <div className="field-wrapper title-divider">Direct Email</div>
              <div className="field-wrapper">
                <label for="forgotUser">Desired Email Name</label>
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control field-direct"
                    aria-label="Enter new email name"
                    aria-describedby="basic-addon2"
                    id="ContactEmail"
                    onChange={(el) =>
                      setAnswer("ContactEmail", el.target.value)
                    }
                    value={answers.ContactEmail}
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text field-direct-addon"
                      id="basic-addon2"
                    >
                      {"@"}
                      {answers.DomainName}
                    </span>
                  </div>
                </div>
              </div>
              {/*<div className="field-wrapper">
                <div className="NoReply spacer-inline">
                  <input
                    className="form-control spacer-margin5 sp-mx"
                    type="checkbox"
                    onChange={(el) => setAnswer("NoReply", el.target.checked)}
                    value={answers.NoReply}
                  />
                </div>
                <label className="v-top">Set as no-reply mailbox</label>
                <aside className="text-reg">
                  Check this box if this mailbox cannot reply to emails.
                </aside>
              </div>*/}
              {errEmail ? (
                <div className="alert alert-danger">
                  Please enter a valid email name with no spaces, commas, or
                  special characters.
                </div>
              ) : null}
            </>
          ) : null}

          {/*Specialty */}
          <div className="field-wrapper title-divider">Specialty</div>
          <div className="field-wrapper text-reg">
            This section is optional but we highly recommend you select these
            options to identify specific areas of focus in the organization.{" "}
            <b className="or-clr">
              If you select a type, then you must select both classification and
              specialization.
            </b>
          </div>
          <SpecialtyDropdown
            //codes={orgValues?.codes}
            SpecialFormFields={(el, val) => SpecialFormFields(el, val)}
            editObj={userEditDetails?.specialties}
          />
          {specialtiesFlag && frmSubmFlag ? (
            <div className="alert alert-danger" id="SpecialtyId">
              Specialization is required when you are selecting Type or
              Classification.
            </div>
          ) : null}
          {errCreateMsg ? (
            <div
              className={`alert alert-danger`}
              dangerouslySetInnerHTML={{ __html: errMsg }}
            />
          ) : null}
          {/*Register Action*/}
          <div className="button-register-container ">
            <div className="spacer-inline text-size4">
              <button
                to={"/success-pre-registration"}
                type="button"
                className="btn btn-success"
                onClick={AddUserRegistration}
              >
                {" "}
                Register{" "}
              </button>
              <button
                onClick={Confirm}
                type="button"
                className="btn btn-outline-secondary spacer-margin2"
              >
                {" "}
                Cancel{" "}
              </button>
            </div>
            {processing ? (
              <div className="loading"></div>
            ) : //<div class="spacer-inline">
            //  <div class="reverse-spinner spinner1"></div>
            //  <div class="spacer-inline spacer-margin2 text-size6">
            //    Processing...
            //  </div>
            //</div>
            null}
          </div>
        </div>
      </div>
      <div className="ConfirmModal">
        <div
          className="modal fade"
          id="ConfirmModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="Cancel PreRegistration"
          aria-hidden="false"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title" id="myModalLabel">
                  Confirmation
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="false">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="alert-warning-o">
                  <i
                    className="bi bi-exclamation-circle"
                    alt="Success Checkmark"
                  ></i>
                </div>

                <div className="message-wrapper">
                  Are you sure want to cancel your registration?
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  to={"/"}
                  onClick={(e) => {
                    $(".modal").modal("hide");
                    e.preventDefault();
                    logout();
                  }}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  data-dismiss="modal"
                >
                  {" "}
                  Cancel{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FormUserContact.defaultProps = {};

export default FormUserContact;
